// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const PARAMETER_OPTIMIZATION_DATASET_CONFIGURATION_STEP_SHAPES = [
  {
    stepType: PipelineStepType.PARAMETER_OPTIMIZATION_DATASET_CONFIGURATION,
    isDeprecated: true,
    version: 0,
    inputDataShapes: {},
    outputDataShapes: {
      'Model training input': {
        systemName: 'Model training input',
        displayName: 'Model training input',
        kind: PipelineStepDataKind.DATASET,
        isMulti: true,
        isRequired: true
      },
      'Feature data': {
        systemName: 'Feature data',
        displayName: 'Feature data',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Feature descriptions': {
        systemName: 'Feature descriptions',
        displayName: 'Feature descriptions',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Label data': {
        systemName: 'Label data',
        displayName: 'Label data',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Label description': {
        systemName: 'Label description',
        displayName: 'Label description',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      datasetConfiguration: {
        kind: 'anything',
        required: true
      },
      dataDefinitionConfig: {
        kind: 'anything',
        required: true
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
